import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { IFile } from 'src/app/_interfaces/files/i-files';
import { ITests } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { EhrTestResultsFilesServiceService } from 'src/app/_services/patient-emr/ehr-test-results-files-service.service';

@Component({
  selector: 'app-upload-multiple-files-with-content-modal',
  templateUrl: './upload-multiple-files-with-content-modal.component.html',
  styleUrls: ['./upload-multiple-files-with-content-modal.component.scss']
})
export class UploadMultipleFilesWithContentModalComponent implements OnInit {
  @Input() recentMedicalTests: boolean = false
  constructor(private ehrTestResultsFilesServiceService: EhrTestResultsFilesServiceService) { }

  ngOnInit(): void {
  }

  public event: EventEmitter<any> = new EventEmitter();
  title: string;
  subtitle: string;
  filesExisted: IFile[];
  isUploadable: boolean = true;
  isHaveContent: boolean = false;
  testDate: Date;
  doctorName: string = '';
  isUpdate: boolean;
  isHaveSelect: boolean = false;
  selectTitle: string;
  selectFirstOptionValue: string;
  selectOptions: { key: number, value: string }[] = [];
  selectedOption: number = null;
  tests: ITests[] = []
  testsIds: number[] = []
  deleteExistedFile(event) {
    this.event.emit(event);
  }

  addedFiles(event) {
    event.testDate = this.testDate
    if (this.selectedOption) {
      event.selectedOption = this.selectedOption;
    }
    if (this.testsIds.length) {
      event.testsIds = this.testsIds
    }
    if (this.doctorName) {
      event.doctorName = this.doctorName
    }
    this.event.emit(event);
  }

  getTestsByTypeId(selectedOption: number) {

    this.ehrTestResultsFilesServiceService.getTestsByTypeId(selectedOption).subscribe((res) => {
      this.testsIds = []
      this.tests = res.data.tests
    })
  }
}
